import React, { useRef, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { getTopStoryIds, getItem } from '../api/hn_api';
import LoadOnScroll from './LoadOnScroll';
import StoryBox from './StoryBox';
import _ from 'underscore'

import { localStorageOrDefault } from './util'


const StoryListPage = ({ numStories, offlineMode, staleAfterMins}) => {
    const latestRefresh = useCallback(() => JSON.parse(localStorageOrDefault('latestRefresh', false)))
    
    const skipRefresh = Date.now() - latestRefresh() < staleAfterMins * 60 * 1000;


    const [stories, setStories] = useState({});
    const storyIDs = useRef([])
    const storyIDCursor = useRef(0);

    const refreshStories = async (initial=false) => {
      try {
        await setStories(() => ({}))
        const new_storyIDs = await getTopStoryIds(offlineMode || (initial && skipRefresh));
        storyIDs.current = new_storyIDs
        storyIDCursor.current = 0
        await loadStories(initial)
      } catch (error) {
        console.error('Error fetching story IDs:', error);
      }
    }

    const loadStories = async (initial=false) => {
        const batch = storyIDs.current.slice(storyIDCursor.current, storyIDCursor.current + numStories)
        for (const itemId of batch) {
          try {
            const story = await getItem(itemId, offlineMode || (initial && skipRefresh));    
            setStories(prevStories => ({...prevStories, [`${story.id}`]: story}));
          } catch (itemError) {
            console.error(`Error fetching item ${itemId}:`, itemError);
          }
        }
        if (!initial || !skipRefresh) {
          localStorage.setItem('latestRefresh', Date.now())
        }
        storyIDCursor.current = storyIDCursor.current + numStories
    }
  

      const render_story = (story) => {
        const rightSide = (
          <Link to={`/story/${story.id}`}> 
            <div className='flex flex-col mr-5 w-30 gap-4'>       
                                
              <div className='flex flex-row items-center gap-1 justify-end'>
                  <i className="fas fa-arrow-up px-1"></i>
                  <span>  {story.score} </span> 
              </div>
              <div className='flex flex-row items-center gap-3 justify-end'>
                  <div className='w-[15px] h-[15px] mt-[-.5em]'>
                      {localStorage.getItem(`story-comments-cached-${story.id}`) ? 
                      (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                          <rect width="24" height="24" fill="none" />
                          <g fill="none">
                              <path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
                              <path fill="currentColor" d="M19 10a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3v.966c0 1.06-1.236 1.639-2.05.96L14.638 19H12a3 3 0 0 1-3-3v-3a3 3 0 0 1 3-3zm-3-6a3 3 0 0 1 3 3v1h-8a4 4 0 0 0-4 4v4c0 1.044.4 1.996 1.056 2.708L7 19.5c-.824.618-2 .03-2-1V17a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3z" />
                          </g>
                          </svg>) :
                      (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                          <rect width="24" height="24" fill="none" />
                          <g fill="none">
                              <path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
                              <path fill="currentColor" d="M16 4a3 3 0 0 1 2.995 2.824L19 7v2a3 3 0 0 1 2.995 2.824L22 12v4a3 3 0 0 1-2.824 2.995L19 19v.966c0 1.02-1.143 1.594-1.954 1.033l-.096-.072L14.638 19H11a3 3 0 0 1-1.998-.762l-.14-.134L7 19.5c-.791.593-1.906.075-1.994-.879L5 18.5V17a3 3 0 0 1-2.995-2.824L2 14V7a3 3 0 0 1 2.824-2.995L5 4zm3 7h-8a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3.638a2 2 0 0 1 1.28.464l1.088.906A1.5 1.5 0 0 1 18.5 17h.5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1m-3-5H5a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h.5A1.5 1.5 0 0 1 7 16.5v.5l1.01-.757A3 3 0 0 1 8 16v-4a3 3 0 0 1 3-3h6V7a1 1 0 0 0-1-1" />
                          </g>
                      </svg>)}
                  </div>
                  <span> {story.descendants} </span>
              </div>
            </div>
          </Link>
        )
        return <StoryBox key={story.id} story={story} rightSide={rightSide} />
      }
    
      const stories_rendered = _.filter(_.map(storyIDs.current, (id) => {
        const story = stories[id]
        if (story === undefined) return false
        return render_story(story)
      }))


    return (
        <LoadOnScroll refreshContent={refreshStories} loadMoreContent={loadStories} startHidden={skipRefresh} disabled={offlineMode}>
            {stories_rendered} 
        </LoadOnScroll>
    );
};

export default StoryListPage;